/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Trans } from 'react-i18next';

type InsightClickHandler = (insightType: string, detail?: string) => void;

// Fallback regions in case there are less than 3 provided
const fallbackRegions = ['Region 1', 'Region 2', 'Region 3'];

// Determine the correct translation key based on the number of regions
const getRegionKey = (count: number): string => {
  if (count <= 1) return 'SMART_INSIGHTS_REGION_PLAYED_ONE';
  if (count === 2) return 'SMART_INSIGHTS_REGION_PLAYED_TWO';
  return 'SMART_INSIGHTS_REGION_PLAYED_THREE';
};

// Render the Trans component with clickable region highlights
export const renderRegionTransContent = (
  topRegions: string[],
  onInsightClick: InsightClickHandler
): React.ReactNode => {
  const [region1, region2, region3] = [...topRegions, ...fallbackRegions].slice(
    0,
    3
  );

  // Get the appropriate translation key
  const key = getRegionKey(topRegions.length);

  // Function to build clickable highlighted region elements
  const buildHighlight = (region?: string) => (
    <strong
      style={{
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={(event) => {
        event.stopPropagation();
        onInsightClick('region', region);
      }}
    />
  );

  // Prepare components for Trans
  const components = {
    ...(region1 ? { region1: buildHighlight(region1) } : {}),
    ...(region2 ? { region2: buildHighlight(region2) } : {}),
    ...(region3 ? { region3: buildHighlight(region3) } : {}),
  };

  return (
    <Trans
      i18nKey={key}
      values={{ region1, region2, region3 }}
      components={components}
    />
  );
};
